/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

/**
 * The styled components for ChartDynamic
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.3.1
 * @since 1.1.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../../../theme';

export const ChartDynamicStyled = styled.div.attrs({
    'className': 'chart chart_dynamic',
    'data-module': 'chartDynamic',
})`
    position: relative;
    width: 100%;

    .chart-legend_dynamic {
        max-height: 125px;
    }

    /*
    * -------------------------------------------
    *           TOOLTIP
    * -------------------------------------------
    */

    .chart-dynamic__tooltip {
        box-sizing: border-box;
        position: absolute;
        width: 320px;
        padding: 20px;
        box-shadow: 0 2px 12px 0 rgba(51, 51, 51, 0.2);
        background: ${colors.backgroundColorWhite};
        pointer-events: none;
        z-index: 11;

        .chart-dynamic__title {
            margin-bottom: 24px;

            .tooltip__title-date {
                ${fonts.textMainBold};
            }
        }

        .tooltip__items {
            list-style-type: none;
            padding: 0;
            margin: 0;
            ${fonts.textSmall};

            .tooltip__item {
                flex-direction: column;
                display: flex;
                margin-bottom: 12px;

                .tooltip-row {
                    display: flex;
                    align-items: center;
                    margin-bottom: 2px;
                }

                .tooltip__item-color {
                    width:8px;
                    height:8px;
                    min-width: 8px;
                    border-radius:50%;
                    margin-right:8px;
                }

                .tooltip__item-info {
                    flex-direction: column;
                    flex-grow: 1;
                    display: flex;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .tooltip__item-price {
                    flex-shrink: 0;
                    margin-left: 8px;
                    text-align: right;
                }

                .tooltip-info__item-subtitle {
                    margin-left: 16px;
                    color: ${colors.textColorOpacity};
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
            }

            .tooltip__item:last-child {
                margin-bottom: 0;
            }

        }
    }
`;
